/*
  Sternify's own storefront script (app.sternify.com/storefront/st-product-information.js)
  emits a theme cart event after its own add-to-cart, then ~900ms later checks
  whether the drawer's innerHTML length changed to decide if the theme handled
  it. If not, it falls through its own chain (official Shopify.actions.openCart,
  then driving a drawer reference directly) to make sure the customer sees
  their cart. Confirmed directly, repeatedly, with a single plain item and
  nothing else involved: this check is misfiring on this store even though the
  theme DID handle the add correctly the first time - HTMLDialogElement.
  prototype.showModal was seen firing on the cart dialog TWICE per add, the
  second call landing ~950-1050ms after the first (matching Sternify's own
  documented ~900ms delay almost exactly), even though the drawer was already
  open, already showed the right contents, and nothing in this theme's own
  code or ours calls showModal a second time. That harmless-looking redundant
  reopen is what visibly played the slide-in animation twice.

  Sternify's script is loaded cross-origin from app.sternify.com and isn't
  ours to edit or debug further, so instead of trying to stop it from being
  called, this intercepts the call itself: HTMLDialogElement.prototype.
  showModal is wrapped globally (this only affects the cart dialog specifically
  - every other dialog on the page is untouched), and a second call arriving
  within 2 seconds of a genuine first one is still let through (never block a
  call outright - if something upstream already force-closed the dialog
  expecting this call to reopen it, silently no-op'ing would leave the
  customer looking at a closed cart), just with the CSS entrance animation
  suppressed for that one call so the net visible effect is "nothing happened"
  rather than "it opened again".

  A second, independent issue this file used to guard against - the drawer's
  <dialog> losing its `open` attribute during a native cart-items morph - was
  fixed at the actual source instead (snippets/cart-drawer.liquid's dialog now
  has a fixed height, so its layout never depends on how much cart content
  currently exists - see that file's comments). The childList/subtree watch
  below is unrelated to that and stays as a safety net for Sternify's other,
  fully destructive rebuild path (whole-section replacement when it believes
  the drawer is closed), which is a different scenario from the redundant-
  reopen one above.
*/
(function () {
  var lastGenuineOpenAt = 0;

  var origShowModal = HTMLDialogElement.prototype.showModal;
  HTMLDialogElement.prototype.showModal = function () {
    var isCartDialog = this.closest && this.closest('cart-drawer-component');
    if (isCartDialog) {
      var now = Date.now();
      var isRedundant = now - lastGenuineOpenAt < 2000;
      lastGenuineOpenAt = now;

      if (isRedundant) {
        var el = this;
        el.classList.add('hh-suppress-open-animation');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.remove('hh-suppress-open-animation');
          });
        });
      }
    }
    return origShowModal.apply(this, arguments);
  };

  var style = document.createElement('style');
  style.textContent = '.hh-suppress-open-animation { animation: none !important; }';
  document.head.appendChild(style);
})();

(function () {
  var cartUpdatedAt = 0;
  var userClosedAt = 0;

  document.addEventListener('cart:update', function () {
    cartUpdatedAt = Date.now();
  });

  document.addEventListener(
    'dialog:close',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer-component')) {
        userClosedAt = Date.now();
      }
    },
    true
  );

  function maybeReopen() {
    if (!cartUpdatedAt || Date.now() - cartUpdatedAt > 3000) return;
    if (userClosedAt > cartUpdatedAt) return;

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || typeof drawer.open !== 'function') return;

    var dialog = drawer.querySelector('dialog');
    if (dialog && !dialog.hasAttribute('open')) {
      drawer.open();
    }
  }

  function init() {
    var drawer = document.querySelector('cart-drawer-component');
    var section = drawer && drawer.closest('[id^="shopify-section-"]');
    if (!section) return;

    new MutationObserver(maybeReopen).observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
